<template>
  <div :id="componentId" class="sp3-module-2" :style="moduleStyle">
    <div
      class="sp3-scroll-wrap"
      :style="{ backgroundImage: scrollImageUrl ? `url(${scrollImageUrl})` : 'none' }"
    >
      <div v-if="!scrollImageUrl" class="sp3-scroll-placeholder">请配置画卷底图</div>

      <div class="sp3-content">
        <div class="sp3-tab-bar">
          <div
            v-for="(tab, index) in displayTabList"
            :key="index"
            class="sp3-tab-item"
            :class="{ active: activeTab === index }"
            @click="handleTabClick(index)"
          >
            {{ tab.title || '标题' }}
          </div>
        </div>

        <div class="sp3-image-area">
          <div
            v-for="(imgUrl, imgIndex) in displayImageList"
            :key="imgIndex"
            class="sp3-image-frame"
            :style="frameStyle"
          >
            <img
              v-if="imgUrl"
              class="sp3-image-content"
              referrerpolicy="no-referrer"
              :src="imgUrl"
            >
            <div v-else class="sp3-image-placeholder">图片</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_TAB = {
  title: '中国品牌',
  imageList: ['', '', '']
}

export default {
  name: 'SpThreeModule2',
  props: {
    componentId: {
      type: String,
      default: 'sp_three_module_2'
    }
  },
  data() {
    return {
      bgColor: '#A93738',
      scrollImageUrl: 'https://image.cbrand.com.cn/tmp/90709b7cb3444c9fdec206804c4f3863.png',
      frameImageUrl: 'https://image.cbrand.com.cn/tmp/1293429592788664fdf40b88673dc2d3.png',
      tabList: [
        { ...DEFAULT_TAB },
        { ...DEFAULT_TAB },
        { ...DEFAULT_TAB }
      ],
      activeTab: 0
    }
  },
  computed: {
    displayTabList() {
      const list = (this.tabList || []).slice(0, 6)
      if (list.length === 0) {
        return [{ ...DEFAULT_TAB }]
      }
      return list
    },
    displayImageList() {
      const tab = this.displayTabList[this.activeTab] || this.displayTabList[0] || { ...DEFAULT_TAB }
      const list = (tab.imageList || []).slice(0, 3)
      while (list.length < 3) {
        list.push('')
      }
      return list
    },
    moduleStyle() {
      return {
        backgroundColor: this.bgColor
      }
    },
    frameStyle() {
      return {
        backgroundImage: this.frameImageUrl ? `url(${this.frameImageUrl})` : 'none'
      }
    }
  },
  methods: {
    handleTabClick(index) {
      this.activeTab = index
    }
  }
}
</script>

<style scoped>
.sp3-module-2 {
  position: relative;
  width: 100%;
  padding: 24px 0 32px;
  box-sizing: border-box;
  overflow: hidden;
}

.sp3-scroll-wrap {
  position: relative;
  width: calc(100% - 24px);
  height: auto;
  min-height: 360px;
  margin: 0 auto;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.sp3-scroll-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
  background: #E0E0E0;
}

.sp3-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 56px 24px 40px;
  box-sizing: border-box;
}

.sp3-tab-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
  padding: 4px 0;
  background: linear-gradient(270deg, rgba(234, 224, 216, 0) 0%, #EBDAAB 50.17%, rgba(243, 237, 233, 0) 100%);
  border-radius: 8px;
  box-sizing: border-box;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.sp3-tab-bar::-webkit-scrollbar {
  display: none;
}

.sp3-tab-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 76px;
  height: 34px;
  padding: 0 12px;
  font-size: 14px;
  color: #000000;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 6px;
}

.sp3-tab-item.active {
  color: #FFFFFF;
  background: linear-gradient(270deg, #CB2F30 0%, #E96E74 100%);
}

.sp3-image-area {
  display: flex;
  align-items: flex-start;
  justify-content: left;
  flex-wrap: wrap;
  gap: 0;
  width: 100%;
  margin-top: 24px;
}

.sp3-image-frame {
  position: relative;
  width: 33.33%;
  max-width: 200px;
  aspect-ratio: 365 / 477;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  flex-shrink: 0;
}

.sp3-image-content {
  position: absolute;
  top: 7%;
  left: 9.8%;
  width: 76%;
  height: 79%;
  object-fit: cover;
  border-radius: 12px;
  display: block;
}

.sp3-image-placeholder {
  position: absolute;
  top: 7%;
  left: 9.8%;
  width: 76%;
  height: 79%;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
  background: #E0E0E0;
}
</style>
